import { useARC } from "providers/ARC/ARCProvider";
import { useTranslation } from "react-i18next";
import { useFeatures } from "providers/FeaturesProvider";
import { useArmControl } from "providers/ArmControlProvider";
import { useGimbalControl } from "providers/GimbalControlProvider";

import FunctionalButton from "components/layout/FunctionalButton";

import { ReactComponent as ControlArmIcon } from "assets/svgs/navbar/robot-arm-svgrepo-com.svg";

import { ConnectionState } from "lib/consts/ARC/connection";

const ControlArmButton = () => {
    const { t } = useTranslation("control");
    const { connectionState } = useARC();
    const { hasArm } = useFeatures();
    const { controlArm, setControlArm, sendArmCmdVelZero } = useArmControl();
    const { controlGimbal, setControlGimbal } = useGimbalControl();

    const isConnectedToARC = connectionState === ConnectionState.Connected;
    const isEnabled = isConnectedToARC && hasArm;

    if (!hasArm) {
        return null;
    }

    const onClick = () => {
        const next = !controlArm;
        if (next && controlGimbal) {
            setControlGimbal(false);
        }
        if (!next) {
            sendArmCmdVelZero();
        }
        setControlArm(next);
    };

    return (
        <FunctionalButton
            className={`control-button-type3 ${controlArm && "control-button-active"} ${
                !isEnabled && "control-button-disable"
            }`}
            icon={
                <ControlArmIcon
                    className={`h-6 w-6 shrink-0 ${!isEnabled && "text-black70"}`}
                    style={{ width: "1.5rem", height: "1.5rem" }}
                />
            }
            hoverText={t("buttons.controlArm")}
            disabled={!isEnabled}
            onClick={onClick}
        />
    );
};

export default ControlArmButton;
